export class StringDto {
    public value: string;
  }